import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseButton from '../CloseButton/CloseButton';

const HeaderContainer = ({ children }) => (
  // allow children to wrap/shrink; gap gives breathing room when title wraps
  <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={2} sx={{ gap: 2 }}>
    {children}
  </Box>
);

const HeaderTitle = (props) => (
  <Typography
    {...props}
    sx={{
      fontWeight: 500,
      // allow the title to shrink and wrap inside flex containers
      flex: '1 1 auto',
      minWidth: 0,
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal'
    }}
  />
);

function TermsOfService() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* make Paper a positioned ancestor so absolute CloseButton is positioned relative to it */}
      <Paper elevation={2} sx={{ p: 4, position: 'relative' }}>
        <HeaderContainer>
          <HeaderTitle variant="h3" component="h1">
            {t('termsOfServiceTitle')}
          </HeaderTitle>
          {/* absolutely position the CloseButton in the top-right corner of the Paper */}
          <CloseButton
            onClick={() => navigate('/')}
            size="small"
            color="primary"
            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
          />
        </HeaderContainer>
        
        <Typography variant="body2" align="center" color="text.secondary" gutterBottom>
          {t('lastUpdated')}: October 2025
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('acceptanceTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('acceptanceText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('serviceDescriptionTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('serviceDescriptionText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('userAccountsTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('userAccountsText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('acceptableUseTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('acceptableUseText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('intellectualPropertyTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('intellectualPropertyText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('disclaimersTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('disclaimersText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('limitationOfLiabilityTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('limitationOfLiabilityText')}
          </Typography>
        </Box>

       
      </Paper>
    </Container>
  );
}

export default TermsOfService;
